module.exports = __webpack_public_path__ + "img/in-gj.e229d7c0.svg";